export const stopStickyElement = () => {
  const marginZero = $(".layout-responsive__body");
  const positionRelative = $(".page-header, .page-header--main, .layout-responsive__header, .donate-ua-banner, .alternative-drift-frame, .sv-chat, .sv-control-chat, .sv-chat-wrapper, .course-summary, .section-details-wrapper");
  const positionStatic = $(".services-comparison-table__thead, .section-subtitle, .features-navigation, .js-feature-compare__header, .categories, .sidebar-wrapper, .sidebar, .form-wrapper, .sticky, .guide-sidebar");

  marginZero.css("margin-top", "0");
  positionRelative.css("position", "relative");
  positionStatic.css("position", "static");
};